import React, { useState, useEffect } from 'react';
import '../styles/EpisodeCard.css';
import '../styles/EpisodeLayout.css';
import { Episode } from '../types/Episode';
import { API_BASE_URL } from '../config';
import { useOutletContext } from 'react-router-dom';
import { formatDate } from '../utils/formatDate';
import { bannedWords } from '../utils/bannedWords';
import { stripHtml } from '../utils/sanitizeInput';
import { sportIcons } from '../utils/sportIcons';

interface Comment {
  commentID: number;
  firstName: string;
  lastName: string;
  commentText: string;
  commentDate: string;
}

const EpisodeCard: React.FC<{ episode: Episode }> = ({ episode }) => {
  // ------------------------------
  // COMMENT SYSTEM STATE (DISABLED)
  // ------------------------------
  // const [showCommentBox, setShowCommentBox] = useState(false);
  // const [showComments, setShowComments] = useState(false);
  // const [commentText, setCommentText] = useState('');
  // const [firstName, setFirstName] = useState('');
  // const [lastName, setLastName] = useState('');
  // const [submitting, setSubmitting] = useState(false);
  // const [error, setError] = useState('');
  // const [success, setSuccess] = useState('');
  // const [comments, setComments] = useState<Comment[]>([]);
  // const [showToast, setShowToast] = useState(false);

  const { setToastMessage } = useOutletContext<{ setToastMessage: (msg: string) => void }>();
  const iconSrc = episode.sportName ? sportIcons[episode.sportName] : undefined;

  // ------------------------------
  // COMMENT SUBMIT HANDLER (DISABLED)
  // ------------------------------
  /*
  const handleSubmit = async () => {
    ...
  };
  */

  // ------------------------------
  // FETCH COMMENTS (DISABLED)
  // ------------------------------
  /*
  const fetchComments = async () => {
    ...
  };

  useEffect(() => {
    fetchComments();
  }, [episode.episodeID]);
  */

  return (
    <div className="episode-card">
      <div className="episode-header">
        <div className="episode-title-wrapper">
          {iconSrc && (
            <img
              src={iconSrc}
              alt={episode.sportName}
              className="sport-icon"
            />
          )}
          <h2 className="episode-title">{episode.episodeName}</h2>

          {episode.transcriptionFile && (
            <a
              href={episode.transcriptionFile}
              download
              className="transcript-download"
              title="Download Transcript"
            >
              📝
            </a>
          )}
        </div>

        <div className="episode-date">
          {formatDate(episode.datePublished)}
        </div>
      </div>

      <div className="episode-description">{stripHtml(episode.description)}</div>
      <audio className="episode-audio" controls src={episode.audioFile} />

      {/* -------------------------------------- */}
      {/* COMMENT BUTTONS REMOVED                */}
      {/* -------------------------------------- */}
      {/*
      <div className="comment-button-row">
        <button className="comment-toggle" onClick={() => setShowCommentBox(prev => !prev)}>
          {showCommentBox ? 'Cancel' : 'Add Comment'}
        </button>
        {comments.length > 0 && (
          <button className="comment-toggle" onClick={() => setShowComments(prev => !prev)}>
            {showComments ? '▼ Hide Comments' : '▶ Show Comments'}
          </button>
        )}
      </div>
      */}

      {/* -------------------------------------- */}
      {/* COMMENT BOX REMOVED                    */}
      {/* -------------------------------------- */}
      {/*
      {showCommentBox && (
        <div className="comment-box">
          <input ... />
          <input ... />
          <textarea ... />
          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}
          <button onClick={handleSubmit} disabled={submitting || !commentText.trim()}>
            Submit
          </button>
        </div>
      )}
      */}

      {/* -------------------------------------- */}
      {/* COMMENT LIST REMOVED                   */}
      {/* -------------------------------------- */}
      {/*
      {showComments && comments.length > 0 && (
        <div className="comment-list">
          {comments.map((c, idx) => (
            <div key={c.commentID} className="comment-entry">
              <div className="comment-meta">
                <strong>{c.firstName} {c.lastName}</strong> • {formatDate(c.commentDate)}
              </div>
              <div className="comment-text">{stripHtml(c.commentText)}</div>
              {idx < comments.length - 1 && <hr />}
            </div>
          ))}
        </div>
      )}
      */}

      {/* -------------------------------------- */}
      {/* TOAST REMOVED                          */}
      {/* -------------------------------------- */}
      {/*
      {showToast && (
        <div className="toast-message">
          Comment submitted successfully
        </div>
      )}
      */}
    </div>
  );
};

export default EpisodeCard;